import React, {Component} from 'react';

import { Line } from 'react-chartjs-2';

import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton'

export default class AircraftGraph extends Component{
  
  render() {
    const {openGraph, data, options, graphOnly} = this.props

    return (
      <div>
        { //Chart JS reacts funny with resizing, by redering without Drawer if works great with Graph only
          (graphOnly)?
          <Drawer transitionDuration={7000} id="AircraftGraph"variant="persistent" open={openGraph} anchor="bottom">
            <div className="closeDialog">
              <IconButton className="closeDialog" onClick={this.handleClick}>
                    <CloseIcon className="dialogIcon" edge="end" onClick={this.props.openGraphFromDialog}></CloseIcon>
              </IconButton>              
            </div>
            
            <div className="chartContainer" >
              <Line type="line" classname="chart" height={63} data={data} widthoptions={{ maintainAspectRatio: false }} options={options} ></Line>
            </div>
          </Drawer> :
          <div transitionDuration={7000} id="AircraftGraph" variant="persistent" open={openGraph} anchor="bottom">
            <div className="closeDialog">
                  <IconButton className="closeDialog" onClick={this.handleClick}>
                    <CloseIcon className="dialogIcon" edge="end" onClick={this.props.openGraphFromDialog}></CloseIcon>
                </IconButton>  
            </div>
            <div className="chartContainer">
              <Line type="line" classname="chart" height={63} data={data} widthoptions={{ maintainAspectRatio: false }} options={options} ></Line>
            </div>
          </div>
        }
      </div>
      );
  }
}

